<template>
    <div id="loyalty">
        <div class="hero hero-drops" data-aos="fade">
            <svg class="drop-gray-1" width="439" height="531" viewBox="0 0 439 531" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M322.2 0L26 296.2C10 312.2 10 338.2 26 354.3C42 370.3 68 370.3 84.1 354.3L438.4 0H322.2Z" fill="url(#paint0_linear-svg-1)"/>
                <path d="M277.9 195.1L12 460.9C-4 476.9 -4 502.9 12 519C28 535 54 535 70.1 519L336 253.1C352 237.1 352 211.1 336 195C328 187 317.5 183 307 183C296.4 183.1 285.9 187.1 277.9 195.1Z" fill="url(#paint1_linear)"/>
                <defs>
                <linearGradient id="paint0_linear-svg-1" x1="109" y1="218" x2="615" y2="-14" gradientUnits="userSpaceOnUse">
                <stop stop-color="#EDF0F7" stop-opacity="0.75"/>
                <stop offset="1" stop-color="white"/>
                </linearGradient>
                <linearGradient id="paint1_linear" x1="77.8982" y1="390.109" x2="512.043" y2="218.305" gradientUnits="userSpaceOnUse">
                <stop stop-color="#EDF0F7" stop-opacity="0.75"/>
                <stop offset="1" stop-color="white"/>
                </linearGradient>
                </defs>
            </svg>

            <svg class="drop-gray-2" width="224" height="223" viewBox="0 0 224 223" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M223.1 111.5C223.1 173.1 173.2 223 111.6 223C49.9999 223 0.0998535 173.1 0.0998535 111.5C0.0998535 49.9 49.9999 0 111.6 0C173.2 0 223.1 49.9 223.1 111.5Z" fill="#EDF0F7"/>
            </svg>

            <div class="slider">
                <Slick ref="slick-hero-home" :options="slickOptions">
                    <div class="slide">
                        <div class="image">
                            <img class="thumb" src="img/loyalty/hero.png" />
                        </div>
                        <div class="caption">
                            <div class="text h1">
                                Portiamo nel loyalty un travel booking moderno 
                            </div>
                            <div class="small h4">
                                al passo con le ultime tecnologie e le aspettative dei consumatori.
                            </div>
                        </div>
                    </div>
                </Slick>

                <!--
                <div class="slider--nav">
                    <div id="hero-slider-prev" class="arrow"><SvgChevronLeft /></div>
                    <div id="hero-slider-next" class="arrow"><SvgChevronRight /></div>
                </div>
                -->
            </div>

            <ScrollTo selector="#scroll" />
        </div>

        <section class="boxed-text" data-aos="fade-up" id="scroll">
            <h1 class="text-center h2">
                Loyalty 2.0: l’urgenza di innovare
            </h1>
            <p class="text text-left">
                Il mondo delle soluzioni loyalty è attraversato da forti richieste di innovazione rispetto alle soluzioni tradizionali.
                Le complesse, lunghe e burocratiche raccolte punti, i grandi cataloghi vengono mano a mano sostituiti da 
                <strong>soluzioni più dinamiche e immediate che rispondono meglio alle abitudini e alle attese dei consumatori</strong> e che semplificano la gestione aziendale dei piani tramite la totale digitalizzazione
            </p>
        </section>

        <b-container fluid data-aos="fade-up">
            <section class="b-cards mt-0 pt-0">
                <b-row>
                    <b-col sm="12">
                        <div class="b-slider">
                            <div class="b-slides">
                                <Slick ref="slick" :options="bSlickOptions">
                                    <div class="b-slide">
                                        <div class="content">
                                            <div class="b-card">
                                                <div class="b-card--thumb" style="background-image:url('../../../../img/loyalty/1-vivamod-loyalty-urgenza-di-rinnovare.png')"></div>
                                                <div class="b-card--text">
                                                    <!--<h5 class="b-card--title">UX di marca</h5>-->
                                                    <div class="b-card--link mt-0">
                                                      <p class="text-center">
                                                        Immagina di premiare la registrazione al tuo piano loyalty con <b>crediti travel</b> di piccolo valore, <b>immediatamente utilizzabili e integrabili con carta di credito</b> o altri sistemi di pagamento.
                                                      </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="b-slide">
                                        <div class="content">
                                            <div class="b-card">
                                                <div class="b-card--thumb" style="background-image:url('../../../../img/loyalty/2-vivamod-loyalty-urgenza-di-rinnovare.png')"></div>
                                                <div class="b-card--text">
                                                    <!--<h5 class="b-card--title">UX di marca</h5>-->
                                                    <div class="b-card--link mt-0">
                                                      <p class="text-center">
                                                        Immagina un piano a punti che il cliente può <b>convertire in ogni momento in un credito travel utilizzabile con pochi click</b>.
                                                      </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="b-slide">
                                        <div class="content">
                                            <div class="b-card">
                                                <div class="b-card--thumb" style="background-image:url('../../../../img/loyalty/3-vivamod-loyalty-urgenza-di-rinnovare.png')"></div>
                                                <div class="b-card--text">
                                                    <!--<h5 class="b-card--title">UX di marca</h5>-->
                                                    <div class="b-card--link mt-0">
                                                        <p class="text-center">
                                                          Immagina <b>offerte lampo</b>, per esempio per il compleanno del cliente, con sconti speciali <b>immediatamente utilizzabili</b> per prenotare un viaggio.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="b-slide">
                                        <div class="content">
                                            <div class="b-card">
                                                <div class="b-card--thumb" style="background-image:url('../../../../img/loyalty/4-vivamod-loyalty-urgenza-di-rinnovare.png')"></div>
                                                <div class="b-card--text">
                                                    <!--<h5 class="b-card--title">UX di marca</h5>-->
                                                    <div class="b-card--link mt-0">
                                                        <p class="text-center">
                                                          Immagina di permettere al tuo cliente di prenotare <b>viaggi tematizzati</b> sul suo profilo e <b>stile di vita</b>. In pochi click e da mobile.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </Slick>
                            </div>

                            <div class="b-left" id="b-left">
                                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.3" d="M80 40.0001C80 62.0097 62.0097 80.0001 40.0001 80.0001C17.9905 80.0001 0 62.0097 0 40.0001C0 17.9905 17.9905 0 40.0001 0C62.0097 0 80 17.9905 80 40.0001Z" fill="#CCCCCC"/>
                                    <g filter="url(#filter0_dleft)">
                                    <path d="M70.4305 40.0001C70.4305 56.8422 56.8422 70.4308 40.0001 70.4308C23.1579 70.4308 9.56934 56.8422 9.56934 40.0001C9.56934 23.1579 23.1579 9.5694 40.0001 9.5694C56.8422 9.5694 70.4305 23.3493 70.4305 40.0001Z" fill="white"/>
                                    </g>
                                    <path d="M45.1672 26.8429C45.9328 26.8429 46.507 27.0343 47.0811 27.6084C48.0381 28.5654 48.0381 30.2879 47.0811 31.4362L38.4687 40.0487L47.0811 48.6611C48.0381 49.6181 48.0381 51.3405 47.0811 52.4889C46.1242 53.4458 44.4017 53.4458 43.2534 52.4889L32.727 41.9625C31.7701 41.0056 31.7701 39.2831 32.727 38.1348L43.2534 27.6084C43.8275 27.0343 44.4017 26.8429 45.1672 26.8429Z" fill="#39414E"/>
                                    <defs>
                                    <filter id="filter0_dleft" x="7.56934" y="7.5694" width="66.8612" height="66.8614" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                                    <feOffset dx="1" dy="1"/>
                                    <feGaussianBlur stdDeviation="1.5"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
                                    </filter>
                                    </defs>
                                </svg>
                            </div>
                            <div class="b-right" id="b-right">
                                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.3" d="M80 40.0001C80 62.0097 62.0097 80.0001 40.0001 80.0001C17.9905 80.0001 0 62.0097 0 40.0001C0 17.9905 17.9905 0 40.0001 0C62.0097 0 80 17.9905 80 40.0001Z" fill="#CCCCCC"/>
                                    <g filter="url(#filter0_dright)">
                                    <path d="M70.4305 40.0001C70.4305 56.8422 56.8422 70.4308 40.0001 70.4308C23.1579 70.4308 9.56934 56.8422 9.56934 40.0001C9.56934 23.1579 23.1579 9.5694 40.0001 9.5694C56.8422 9.5694 70.4305 23.3493 70.4305 40.0001Z" fill="white"/>
                                    </g>
                                    <path d="M34.6413 53.2066C33.8758 53.2066 33.3016 53.0152 32.7275 52.441C31.7705 51.4841 31.7705 49.7616 32.7275 48.6133L41.3399 40.0008L32.7275 31.3884C31.7705 30.4314 31.7705 28.7089 32.7275 27.5606C33.6844 26.6037 35.4069 26.6037 36.5552 27.5606L47.0816 38.0869C48.0385 39.0439 48.0385 40.7664 47.0816 41.9147L36.5552 52.441C35.9811 53.0152 35.4069 53.2066 34.6413 53.2066Z" fill="#39414E"/>
                                    <defs>
                                    <filter id="filter0_dright" x="7.56934" y="7.5694" width="66.8612" height="66.8614" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                                    <feOffset dx="1" dy="1"/>
                                    <feGaussianBlur stdDeviation="1.5"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
                                    </filter>
                                    </defs>
                                </svg>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </section>
        </b-container>   

        <section class="section--card-cofanetti credito-travel">
            <b-container fluid>
                <div class="content">
                    <img class="bg" src="img/loyalty/vivamod-bannerone-loyalty.png" />
                    <h2 class="title h4 white" style="top:auto;bottom:20%;">Frictionless loyalty, <br>la conversione ad un click di distanza</h2>
                </div>
                <div class="drop">
                    <img class="bg" src="img/card-cofanetti-bg.svg" />
                    <div class="text">
                        La realizzazione di customer journey che riducono al minimo possibili attriti è la grande lezione che viene dalle evoluzioni dell’ecommerce degli ultimi anni.
                        <br><br>
                        <b>Con Vivamod le logiche frictionless possono trovare applicazione nel mondo del loyalty con soluzioni di travel booking ad un click di distanza dalla fase di guadagno dei punti.</b>
                    </div>
                </div>
            </b-container>
        </section>

        <b-container class="prods mt-0" data-aos="fade-up">
            <section class="mt-0">
                <b-row class="align-items-center">
                    <b-col sm="12" lg="5" offset-lg="1">
                        <h2 class="section--title text-left">Multi-point reward</h2>
                        <p>
                            Il loyalty moderno supera la premialità legata al mero “acquisto” premiando invece il cliente per tutta una serie di operazioni dislocate lungo tutta la customer journey e i diversi touch point.
                        </p>
                        <p>
                            <b>Fornire credito travel immediatamente fruibile è quello che puoi fare facilmente con le nostre soluzioni.</b>
                        </p>
                    </b-col>
                    <b-col sm="12" lg="5">
                        <div class="image">
                            <img src="img/home/phona-prod.png" />
                            <div class="btn btn-lg">
                                <span>scopri di più</span>
                                <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.3" d="M53.4704 27.2272C53.4704 41.7774 41.7057 53.5749 27.1959 53.5749C12.6861 53.5749 0.921387 41.7774 0.921387 27.2272C0.921387 12.6769 12.6861 0.879395 27.1959 0.879395C41.7057 0.879395 53.4704 12.6769 53.4704 27.2272Z" fill="#283D4D"/>
                                    <path d="M47.1958 27.2271C47.1958 38.3168 38.2546 47.2829 27.1958 47.2829C16.137 47.2829 7.1958 38.3168 7.1958 27.2271C7.1958 16.1375 16.137 7.17139 27.1958 7.17139C38.2546 7.17139 47.1958 16.1375 47.1958 27.2271Z" fill="#157FFB"/>
                                    <path d="M23.7452 35.8786C23.2746 35.8786 22.8825 35.7213 22.4903 35.4067C21.7845 34.6989 21.7845 33.5977 22.4903 32.9685L28.2158 27.2271L22.4903 21.4856C21.7845 20.7778 21.7845 19.6767 22.4903 19.0475C23.1962 18.3396 24.2943 18.3396 24.9217 19.0475L31.9021 26.0474C32.608 26.7552 32.608 27.8563 31.9021 28.4855L24.9217 35.4854C24.608 35.7213 24.1374 35.8786 23.7452 35.8786Z" fill="white"/>
                                </svg>                            
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" offset-lg="1">
                        <svg class="dot" width="142" height="142" viewBox="0 0 142 142" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="71" cy="71" r="71" fill="url(#paint0_linear)"/>
                        <defs>
                        <linearGradient id="paint0_linear" x1="70.8509" y1="152.407" x2="70.8508" y2="18.6134" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#FF974F"/>
                        <stop offset="0.00128142" stop-color="#FF974F"/>
                        <stop offset="1" stop-color="#FF5652"/>
                        </linearGradient>
                        </defs>
                        </svg>
                    </b-col>
                </b-row>
            </section>
        </b-container>

        <b-container data-aos="fade-up">
            <section class="text-left mt-0">
                <b-row>
                    <b-col sm="12" lg="8" offset-lg="2">
                        <h2 class="section--title text-center">Rewards, andare oltre lo sconto</h2>
                        <div class="intro">
                            <p class="section--subtitle">
                                L’utilizzo di premialità di terzi, in particolare viaggi, invece di sconti sul proprio prodotto o servizio è stato spesso un privilegio di grandi corporation come le società di emissione di carte di credito o le grandi compagnie aeree.
                            </p>
                            <p>
                                <b>Con Vivamod è semplice introdurre premi travel in ogni piano loyalty con soluzioni integrate di facile gestione e facile fruizione da parte del cliente.</b>
                            </p>
                        </div>
                    </b-col>
                </b-row>

                <br><br><br>

            </section>
        </b-container>   

        <section class="section--card-with-background">
            <img class="floatingImg" src="img/incentive/card-bg.png" />
            <div class="content">
                <div class="card">
                    <div class="icon"><img src="img/loyalty/icon-mobile.svg"/></div>
                    <h3 class="title">Mobile</h3>
                    <p class="text">
                        La dimensione mobile dei piani e delle soluzioni loyalty attuali richiede una premialità digitale, integrata e fruibile su mobile.
                        <br><br>
                        <b>Vivamod offre soluzioni disegnate con una filosofia mobile-first, facilmente integrabili con le tue applicazioni IT.</b>
                    </p>
                </div>
                <div class="card">
                    <div class="icon"><img src="img/loyalty/icon-5g.svg"/></div>
                    <div class="title">5g</div>
                    <p class="text">
                        La prossima irruzione delle connessioni 5g aprirà scenari inesplorati anche sul fronte dell’interattività e dell’immediatezza del loyalty in ogni settore, dai servizi al largo consumo.
                        <br><br>
                        <b>Vivamod è pronto a rispondere a queste evoluzioni con una customer journey e una UX semplice ed immediata.</b>
                    </p>
                </div>
                <div class="card">
                    <div class="icon"><img src="img/loyalty/icon-gaming.svg"/></div>
                    <h3 class="title">Gaming</h3>
                    <p class="text">
                        Sempre più spesso i piani loyalty includono una dimensione di gaming capace di intercettare gli impulsi più istintivi del cliente.
                        <br><br>
                        <b>Immagina di fornire al cliente un credito travel virtuale immediatamente disponibile ed utilizzabile anche su mobile ad ogni mission portata a termine con successo.</b>
                    </p>
                </div>
            </div>
        </section>

        <section class="section--data-insight" data-aos="fade-up">
            <b-container fluid>
                <b-row>
                    <b-col xs="12" sm="6">
                        <div class="content">
                            <h3 class="title">Rewards e profilazione utente</h3>
                            <div class="text">
                                <br>
                                Le nostre soluzioni permettono la creazione di un grande numero di varianti tematiche del premio facilmente adattabili anche a complesse profilazioni della clientela in possesso dell’azienda.
                            </div>
                            <img class="bg" src="svg/bg-insight.svg" />
                        </div>
                    </b-col>
                    <b-col xs="12" sm="6">
                        <div class="image" style="background-image:url('../../../../img/loyalty/vivamod-loyalty-reward-e-profilazione.png')"></div>
                    </b-col>
                </b-row>
            </b-container>
        </section>

        <b-container data-aos="fade-up">
            <section class="text-left">
                <b-row>
                    <b-col sm="12" lg="8" offset-lg="2">
                        <h2 class="section--title text-center">Integrazione IT, branding e tuning valoriale</h2>
                        <div class="intro">
                            <p class="section--subtitle">
                                Le soluzioni Vivamod permettono una integrazione tra la tua piattaforma loyalty e la piattaforma di prenotazione del viaggio creando <b>una customer journey senza interruzioni.</b>
                            </p>
                            <p>
                                Non solo: le soluzioni Vivamod sono facilmente brandizzabili e le proposte possono essere tematizzate e <b>disegnate in base ai messaggi della tua campagna</b> e ai valori della tua azienda.
                            </p>
                        </div>
                    </b-col>
                </b-row>

                <br><br><br>

                <b-row>
                    <b-col sm="12">
                        <div class="text-center h4">Ecco di seguito solo alcune delle <b>infinite possibilità di tematizzazione:</b></div>
                    </b-col>
                </b-row>

                <br><br>

                <b-row>
                    <b-col sm="12">
                        <div class="b-slider">
                            <div class="b-slides">
                                <Slick ref="slick" :options="bSlickOptions2">
                                    <div v-for="(i,index) in [1,2,3,4,5,6]" v-bind:key="index">
                                    <div class="b-slide">
                                        <div class="content">
                                            <img class="phone" src="img/home/slider-sintonizzati/phone.png" />
                                            <img class="screen" :src="'img/loyalty/vivamod-loyalty-slider-phona'+i+'.jpg'" />
                                        </div>
                                    </div>
                                    </div>
                                    <div v-for="(i,index) in [1,2,3]" v-bind:key="index">
                                    <div class="b-slide">
                                        <div class="content">
                                            <img class="phone" src="img/home/slider-sintonizzati/phone.png" />
                                            <img class="screen" :src="'img/loyalty/vivamod-loyalty-slider-phona'+i+'.jpg'" />
                                        </div>
                                    </div>
                                    </div>
                                </Slick>
                            </div>

                            <div class="b-left" id="b-left2">
                                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.3" d="M80 40.0001C80 62.0097 62.0097 80.0001 40.0001 80.0001C17.9905 80.0001 0 62.0097 0 40.0001C0 17.9905 17.9905 0 40.0001 0C62.0097 0 80 17.9905 80 40.0001Z" fill="#CCCCCC"/>
                                    <g filter="url(#filter0_dleft)">
                                    <path d="M70.4305 40.0001C70.4305 56.8422 56.8422 70.4308 40.0001 70.4308C23.1579 70.4308 9.56934 56.8422 9.56934 40.0001C9.56934 23.1579 23.1579 9.5694 40.0001 9.5694C56.8422 9.5694 70.4305 23.3493 70.4305 40.0001Z" fill="white"/>
                                    </g>
                                    <path d="M45.1672 26.8429C45.9328 26.8429 46.507 27.0343 47.0811 27.6084C48.0381 28.5654 48.0381 30.2879 47.0811 31.4362L38.4687 40.0487L47.0811 48.6611C48.0381 49.6181 48.0381 51.3405 47.0811 52.4889C46.1242 53.4458 44.4017 53.4458 43.2534 52.4889L32.727 41.9625C31.7701 41.0056 31.7701 39.2831 32.727 38.1348L43.2534 27.6084C43.8275 27.0343 44.4017 26.8429 45.1672 26.8429Z" fill="#39414E"/>
                                    <defs>
                                    <filter id="filter0_dleft" x="7.56934" y="7.5694" width="66.8612" height="66.8614" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                                    <feOffset dx="1" dy="1"/>
                                    <feGaussianBlur stdDeviation="1.5"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
                                    </filter>
                                    </defs>
                                </svg>
                            </div>
                            <div class="b-right" id="b-right2">
                                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.3" d="M80 40.0001C80 62.0097 62.0097 80.0001 40.0001 80.0001C17.9905 80.0001 0 62.0097 0 40.0001C0 17.9905 17.9905 0 40.0001 0C62.0097 0 80 17.9905 80 40.0001Z" fill="#CCCCCC"/>
                                    <g filter="url(#filter0_dright)">
                                    <path d="M70.4305 40.0001C70.4305 56.8422 56.8422 70.4308 40.0001 70.4308C23.1579 70.4308 9.56934 56.8422 9.56934 40.0001C9.56934 23.1579 23.1579 9.5694 40.0001 9.5694C56.8422 9.5694 70.4305 23.3493 70.4305 40.0001Z" fill="white"/>
                                    </g>
                                    <path d="M34.6413 53.2066C33.8758 53.2066 33.3016 53.0152 32.7275 52.441C31.7705 51.4841 31.7705 49.7616 32.7275 48.6133L41.3399 40.0008L32.7275 31.3884C31.7705 30.4314 31.7705 28.7089 32.7275 27.5606C33.6844 26.6037 35.4069 26.6037 36.5552 27.5606L47.0816 38.0869C48.0385 39.0439 48.0385 40.7664 47.0816 41.9147L36.5552 52.441C35.9811 53.0152 35.4069 53.2066 34.6413 53.2066Z" fill="#39414E"/>
                                    <defs>
                                    <filter id="filter0_dright" x="7.56934" y="7.5694" width="66.8612" height="66.8614" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                                    <feOffset dx="1" dy="1"/>
                                    <feGaussianBlur stdDeviation="1.5"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
                                    </filter>
                                    </defs>
                                </svg>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </section>
        </b-container>   

        <b-container data-aos="fade-up">
            <section class="text-left mt-0">
                <b-row>
                    <b-col sm="12" lg="8" offset-lg="2">
                        <h3 class="section--title text-center">Privacy by design e by default</h3>

                        <br><br>

                        <div class="intro">
                            <p class="">
                                Definiamo con te privacy policy solide e sicure da utilizzare nel trattamento dei dati dei tuoi clienti.
                            </p>
                            <p>
                                Troverai <b>uno staff attento e competente rispetto ad una delle problematiche più importanti del marketing contemporaneo.</b>
                            </p>
                        </div>
                    </b-col>
                </b-row>

            </section>
        </b-container>   

        <b-container data-aos="fade-up">
            <section class="text-left mt-0">
                <b-row>
                    <b-col sm="12" lg="8" offset-lg="2">
                        <h1 class="section--title text-center">Un servizio di assistenza per l’utenza business</h1>

                        <br><br>
                        
                        <div class="intro">
                            <p class="text-center">
                                <b>Far viaggiare i tuoi clienti con le nostre soluzioni travel significa prima di tutto sicurezza</b>
                            </p>
                        </div>
                    </b-col>
                </b-row>

            </section>
        </b-container>   

        <b-container fluid data-aos="fade-up">
            <section class="b-cards mt-0 pt-0">
                <b-row>
                    <b-col sm="12">
                        <div class="b-slider">
                            <div class="b-slides">
                                <Slick ref="slick" :options="bSlickOptions3">
                                    <div class="b-slide">
                                        <div class="content">
                                            <div class="b-card">
                                                <!--<div class="b-card--thumb" style="background-image:url('../../../../img/loyalty/1-vivamod-loyalty-urgenza-di-rinnovare.png')"></div>-->
                                                <img class="text-center m-auto" style="max-height:80px;" src="img/loyalty/icon-doppia-verifica.svg">
                                                <div class="b-card--text mt-4">
                                                    <h3 class="b-card--title">Doppia verifica</h3>
                                                    <div class="b-card--link">
                                                        <p class="">Il nostro protocollo di gestione delle prenotazioni di viaggio prevede verifiche ridondanti a garanzia della sicurezza dei tuoi clienti</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="b-slide">
                                        <div class="content">
                                            <div class="b-card">
                                                <!--<div class="b-card--thumb" style="background-image:url('../../../../img/loyalty/2-vivamod-loyalty-urgenza-di-rinnovare.png')"></div>-->
                                                <img class="text-center m-auto" style="max-height:80px;" src="img/loyalty/icon-whitelist.svg">
                                                <div class="b-card--text mt-4">
                                                    <h3 class="b-card--title">Hotel selezionati</h3>
                                                    <div class="b-card--link">
                                                        <p class="">Con le nostre soluzioni di travel booking permetterai ai tuoi clienti di accedere alle disponibilità di centinaia di migliaia di strutture in tutto il mondo selezionate in base ad algoritmi che ne valutano la qualità e la professionalità</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="b-slide">
                                        <div class="content">
                                            <div class="b-card">
                                                <!--<div class="b-card--thumb" style="background-image:url('../../../../img/loyalty/3-vivamod-loyalty-urgenza-di-rinnovare.png')"></div>-->
                                                <img class="text-center m-auto" style="max-height:80px;" src="img/loyalty/icon-assistenza.svg">
                                                <div class="b-card--text mt-4">
                                                    <h3 class="b-card--title">Call centre interno</h3>
                                                    <div class="b-card--link">
                                                        <p class="">Il nostro centro di assistenza è specializzato nella gestione di utenti ad alto valore aggiunto, utenti di welfare aziendale, incentive al trade, loyalty e marketing</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Slick>
                            </div>
                            <!--
                            <div class="b-left" id="b-left3">
                                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.3" d="M80 40.0001C80 62.0097 62.0097 80.0001 40.0001 80.0001C17.9905 80.0001 0 62.0097 0 40.0001C0 17.9905 17.9905 0 40.0001 0C62.0097 0 80 17.9905 80 40.0001Z" fill="#CCCCCC"/>
                                    <g filter="url(#filter0_dleft)">
                                    <path d="M70.4305 40.0001C70.4305 56.8422 56.8422 70.4308 40.0001 70.4308C23.1579 70.4308 9.56934 56.8422 9.56934 40.0001C9.56934 23.1579 23.1579 9.5694 40.0001 9.5694C56.8422 9.5694 70.4305 23.3493 70.4305 40.0001Z" fill="white"/>
                                    </g>
                                    <path d="M45.1672 26.8429C45.9328 26.8429 46.507 27.0343 47.0811 27.6084C48.0381 28.5654 48.0381 30.2879 47.0811 31.4362L38.4687 40.0487L47.0811 48.6611C48.0381 49.6181 48.0381 51.3405 47.0811 52.4889C46.1242 53.4458 44.4017 53.4458 43.2534 52.4889L32.727 41.9625C31.7701 41.0056 31.7701 39.2831 32.727 38.1348L43.2534 27.6084C43.8275 27.0343 44.4017 26.8429 45.1672 26.8429Z" fill="#39414E"/>
                                    <defs>
                                    <filter id="filter0_dleft" x="7.56934" y="7.5694" width="66.8612" height="66.8614" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                                    <feOffset dx="1" dy="1"/>
                                    <feGaussianBlur stdDeviation="1.5"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
                                    </filter>
                                    </defs>
                                </svg>
                            </div>
                            <div class="b-right" id="b-right3">
                                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.3" d="M80 40.0001C80 62.0097 62.0097 80.0001 40.0001 80.0001C17.9905 80.0001 0 62.0097 0 40.0001C0 17.9905 17.9905 0 40.0001 0C62.0097 0 80 17.9905 80 40.0001Z" fill="#CCCCCC"/>
                                    <g filter="url(#filter0_dright)">
                                    <path d="M70.4305 40.0001C70.4305 56.8422 56.8422 70.4308 40.0001 70.4308C23.1579 70.4308 9.56934 56.8422 9.56934 40.0001C9.56934 23.1579 23.1579 9.5694 40.0001 9.5694C56.8422 9.5694 70.4305 23.3493 70.4305 40.0001Z" fill="white"/>
                                    </g>
                                    <path d="M34.6413 53.2066C33.8758 53.2066 33.3016 53.0152 32.7275 52.441C31.7705 51.4841 31.7705 49.7616 32.7275 48.6133L41.3399 40.0008L32.7275 31.3884C31.7705 30.4314 31.7705 28.7089 32.7275 27.5606C33.6844 26.6037 35.4069 26.6037 36.5552 27.5606L47.0816 38.0869C48.0385 39.0439 48.0385 40.7664 47.0816 41.9147L36.5552 52.441C35.9811 53.0152 35.4069 53.2066 34.6413 53.2066Z" fill="#39414E"/>
                                    <defs>
                                    <filter id="filter0_dright" x="7.56934" y="7.5694" width="66.8612" height="66.8614" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                                    <feOffset dx="1" dy="1"/>
                                    <feGaussianBlur stdDeviation="1.5"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
                                    </filter>
                                    </defs>
                                </svg>
                            </div>
                            -->
                        </div>
                    </b-col>
                </b-row>
            </section>
        </b-container>   













        

        <b-container data-aos="fade-up">
            <section>
                <FormContatti
                    formTitle="Contattaci"
                    formSubtitle="Contattaci per capire come integrare il travel nei tuoi progetti loyalty"
                />
            </section>
        </b-container>

        <section class="section--prefooter" data-aos="fade-up">
            <b-container fluid>
                <b-row>
                    <b-col sm="6">
                        <div class="content">
                            <h3 class="subtitle">
                                I piani loyalty: cosa sono e dove vanno
                            </h3>
                            <div class="text">
                                <p>
                                    I loyalty program sono programmi progettati per ricompensare i clienti fedeli e per incoraggiarli a restare tali attraverso sconti, premi o esperienze esclusive
                                </p>
                                <p>
                                    I programmi fedeltà sono tipicamente organizzati intorno all’area dei “premi” e si distinguono in base alla natura del premio ed alle modalità con cui il cliente si qualifica per il premio. 
                                    <br>
                                    Il premio può consistere in un bene, un servizio o un privilegio e può essere ottenuto grazie al semplice possesso della carta, all’appartenenza ad un club o alla raccolta punti. 
                                </p>
                                <p>
                                    Nel tempo si è verificato un graduale cambiamento dei loyalty program. Le prime campagne promozionali erano semplici, paper-based, con raccolta punti e catalogo premi. In seguito i programmi fedeltà sono divenuti “nominativi”, con database per la raccolta dei dati dei consumatori con lo scopo di avviare un processo di analisi e successivo indirizzamento degli acquisti. Lo step successivo è stato l’ingresso di Internet e l’utilizzo dei portali, mailing list per consultare cataloghi e promozioni attive, verificando il proprio saldo punti anche da casa ed in mobilità. Con la diffusione di nuove tecnologie si comincia a parlare di mobile loyalty: voucher, digital coupon, premi in forma di traffico telefonico/sms e/o di premi erogati in modo istantaneo ed efficace utilizzando il dispositivo mobile del cliente.
                                </p>
                                <p>
                                    I premi a catalogo non sono più “attractive” come in passato o almeno non quanto i premi di natura tecnologica e informatica, sconti attraverso iniziative di co-marketing con partner diversi provenienti dal mondo delle benzine, della grande distribuzione alimentare, delle compagnie aeree o delle agenzie di viaggi. 
                                </p>
                                <p>
                                    Il target di consumatori delle campagne orientate al cliente sta cambiando, spostandosi dalle famiglie verso gli “Youngers”, verso i Millenials e verso la Z Generation utenti “High Mobile Users”. L’attività di collezione punti, attivazione di carte fedeltà, distribuzione di cataloghi premi, lascerà il posto e/o si arricchirà con nuovi programmi di Mobile Loyalty.
                                </p>
                                <p>
                                    Un efficace loyalty program oggi permette di: 
                                    <br><br>
                                    - ridurre il churn rate e migliorare il tasso di retention <br>
                                    - aumentare la quota di acquisti del cliente <br>
                                    - acquisire dati sui comportamenti di acquisto e di consumo e quindi di individuare nuove modalità di accrescimento del valore per il cliente e per l’impresa
                                </p>
                            </div>
                        </div>
                    </b-col>
                    <b-col sm="6">
                        <div class="image">
                            <div class="image" style="background-image:url('../../../../img/loyalty/vivamod-loyalty-didascalia.jpg')"></div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </section>

    </div>
</template>

<script>
    import Slick from 'vue-slick'
    import FormContatti from '@/components/blocks/form-contatti'
    import ScrollTo from '@/components/atoms/scroll-to'
    //import SvgChevronLeft from '@/components/svg/chevron-left'
   // import SvgChevronRight from '@/components/svg/chevron-right'
    
    export default {
        name: 'loyalty',
        metaInfo: {
          title: 'Loyalty Program - Travel per i piani di fidelizzazione',
          meta: [
            { vmid: 'metaDescription', name: 'Description', content: 'Programmi Loyalty: portiamo nel loyalty un travel booking moderno al passo con le ultime tecnologie e le aspettative dei consumatori' },
            { vmid: 'dcDescription', name: 'DC.description', lang: 'it', content: 'Programmi Loyalty: portiamo nel loyalty un travel booking moderno al passo con le ultime tecnologie e le aspettative dei consumatori' },
            { vmid: 'ogTitle', property: 'og:title', content: 'Loyalty Program - Travel per i piani di fidelizzazione | Vivamod' },
            { vmid: 'ogDescription', name: 'og:description', content: 'Programmi Loyalty: portiamo nel loyalty un travel booking moderno al passo con le ultime tecnologie e le aspettative dei consumatori' },
          ],
        },
        components: {
            Slick,
            FormContatti,
            ScrollTo,
            //SvgChevronLeft,
            //SvgChevronRight,
        },
        data()
        {
            return {
                slickOptions: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots:false,
                    fade:true,
                    arrows:true,
                    autoplay:true,
                    speed: 1500,
                    autoplaySpeed: 5500,
                    prevArrow: '#hero-slider-prev',
                    nextArrow: '#hero-slider-next',
                    responsive: [{
                        /*
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                        */
                    }]
                },
                bSlickOptions: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        dots:false,
                        //fade:true,
                        //arrows:false,
                        //autoplay:true,
                        speed: 500,
                        //autoplaySpeed: 7500,
                        prevArrow: '#b-left',
                        nextArrow: '#b-right',
                        responsive: [
                            {
                            breakpoint: 1140,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1,
                                }
                            },
                            {
                            breakpoint: 600,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                }
                            }
                        ]
                },
                bSlickOptions2: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        dots:false,
                        //fade:true,
                        //arrows:false,
                        //autoplay:true,
                        speed: 500,
                        //autoplaySpeed: 7500,
                        prevArrow: '#b-left2',
                        nextArrow: '#b-right2',
                        responsive: [
                            {
                            breakpoint: 1140,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1,
                                }
                            },
                            {
                            breakpoint: 600,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                }
                            }
                        ]
                },
                bSlickOptions3: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        dots:false,
                        //fade:true,
                        //arrows:false,
                        //autoplay:true,
                        speed: 500,
                        //autoplaySpeed: 7500,
                        prevArrow: '#b-left3',
                        nextArrow: '#b-right3',
                        responsive: [
                            {
                            breakpoint: 1140,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1,
                                }
                            },
                            {
                            breakpoint: 600,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                }
                            }
                        ]
                },
            }
        },
        methods: {
        },
        mounted()
        {
        }
    }
</script>

<style lang="scss">
    @import "~bootstrap/scss/functions";
    @import "~bootstrap/scss/mixins";
    @import './../../scss/_custom.scss';

    #loyalty
    {
        .hero-drops
        {
            width:100%;
            overflow:hidden;
            max-width:1920px;
            position:relative;

            .drop-gray-1
            {
                position:absolute;
                top:46px;
                left:25%;
                width:46px;
                height:auto;
            }

            .drop-gray-2
            {
                position: absolute;
                top: 75%;
                left: 40%;
                width: 40px;
                height: auto;
            }

            .slider
            {
                position:relative;
                &--nav
                {
                    position:absolute;
                    padding:5px;
                    bottom:0;
                    display:flex;
                    .arrow
                    {
                        cursor:pointer;
                        transition:$transition-base;
                        &:hover
                        {
                            opacity:0.7;
                        }
                        path
                        {
                            stroke:$secondary;
                        }
                    }
                    @include media-breakpoint-up(lg)
                    {
                        right:0;
                        bottom:60px;
                        left:auto;
                        .arrow
                        {
                            padding:10px 20px;
                            svg
                            {
                                height:auto;
                                width:40px;
                            }
                        }
                    }
                }
            }
            .slide
            {
                //background-size: contain;
                //background-position: center center;
                //min-height: 200px;
                width:100%;
                //border:1px solid red;
                display:flex !important; //altrimenti slick, as usual, la sovrascrive con inline-block
                justify-content: flex-end;
            }
            .image
            {
                width:55%;
                position:relative;
                margin:30px 0;
                transform:translateX((5%))
            }
            .thumb
            {
                height: auto;
                width:100%;
            }
            .caption
            {
                position:absolute;
                top:50%;
                left:0;
                width:55%;
                //transform:translateY(-50%);
                padding:$grid-gutter-width/6;
                //border:1px solid green;
            }
            .small
            {
                color:$dark-blue;
                display:none;
                //font-weight: 400;
            }
            .text
            {
                //margin:0.25rem 0;
                color:$tertiary;
            }

            @include media-breakpoint-up(sm)
            {
                margin-bottom:80px;
                .drop-gray-1
                {
                    width:65px;
                    left:18.5%;
                    top:26.5%;
                }
                .drop-gray-2
                {
                    top: 82%;
                    left: 40%;
                    width: 60px;
                }
                .slider
                {

                }
                .slide
                {
                }
                .image
                {
                    width:60%;
                    margin:0;
                    transform:translateX(5%) translateY(-3.5%);
                }
                .thumb
                {
                }
                .caption
                {
                    padding: 0;
                    padding-left:$grid-gutter-width/2;
                    font-size:16px;
                    top:auto;
                    bottom:0;
                    width:55%;
                }
                .small
                {
                    display:block;
                    //max-width:220px;
                }
                .text
                {
                    margin:0.5rem 0;
                }
            }

            @include media-breakpoint-up(lg)
            {
                .drop-gray-1
                {
                    width: 160px;
                    left: 5.5%;
                    top: 0;
                }
                .drop-gray-2
                {
                    top: 80%;
                    left: 30%;
                    width: 80px;
                }
                .caption
                {
                    bottom:auto;
                    top:50%;
                    transform: translateY(-30%);
                    width:50%;
                }
                .small
                {
                    max-width:400px;
                    &:first-child
                    {
                        bottom:100%;
                    }
                    &:last-child
                    {
                        top:100%;
                    }
                }
                .text
                {
                    //line-height:120%;
                    margin:1rem 0;
                    //font-size:36px;
                    //max-width:400px;
                }                    
            }

            @include media-breakpoint-up(xxl)
            {

                .slider
                {

                }
                .slide
                {
                }
                .image
                {
                    //width:60vw;
                    //transform:none;
                    max-width:1200px;
                    top:0px;
                }
                .thumb
                {
                    top:4px;
                }
                .caption
                {
                    padding:0;
                    margin:0 $grid-gutter-width*2;
                    //font-size:16px;
                    transform:translateY(-50%);
                }
                .small
                {
                    max-width:600px;
                    &:first-child
                    {
                        bottom:100%;
                    }
                    &:last-child
                    {
                        top:100%;
                    }
                }
                .text
                {
                    //line-height:120%;
                    margin:1rem 0;
                    //font-size:36px;
                    //max-width:500px;
                }                    
            }            
        }

        @include media-breakpoint-down(xs)
        {
            .hero-drops .text
            {
                font-size: 12px;
            }
            .hero-drops .small
            {
                display:none;
            }
        }

        .extraQuote
        {
            margin-top:0;
            padding-top:0;
            padding-bottom:0 !important;
            br + br
            {
                display:none;
            }
            @include media-breakpoint-up(sm)
            {
                br + br
                {
                    display:block;
                }
            }
            .cta
            {
                display:block;
                font-size:90%;
                margin-bottom: 0;
                margin-top:10px;
                @include media-breakpoint-up(sm)
                {
                    margin-top:30px;
                }
            }
            .text
            {
                top:38%;
                left:37.5%;
                transform:translateY(-50%);
                width:50%;
                @include media-breakpoint-down(sm)
                {
                    font-size: 11px;
                }
                @include media-breakpoint-up(sm)
                {
                    top:42%;
                }
                @include media-breakpoint-up(lg)
                {
                    top:40%;
                }
                @include media-breakpoint-up(xl)
                {
                    
                    left:42%;
                    width:30.5%;
                    top:50%;
                }
            }
        }   

        section.boxed-text
        {
            margin-bottom:140px !important;
            .text
            {
            }
        }
        
        .credito-travel
        {
            margin-bottom:0 !important;
            .title
            {
                color:$dark-blue;
                text-align: center;
                position:absolute;
                top:30%;
                padding:0 4%;
            }

            .drop
            {
                margin-top:-40px;
            }

            @include media-breakpoint-up(md)
            {
                .title
                {
                    width:100%;
                }
            }
            @include media-breakpoint-up(xl)
            {
                .title
                {
                    width:100%;
                }
                .drop
                {
                    max-width: 0px;
                    bottom:80px;
                }
            }
        }

        .section--card-with-background
        {
            @include media-breakpoint-up(sm)
            {
                .card
                {
                    width:calc(50% - #{$grid-gutter-width});
                }

                .card:nth-child(3)
                {

                }

                .card:nth-child(2),
                .card:nth-child(4)
                {
                    transform:translateY(15%);
                }
            }
            @include media-breakpoint-up(lg)
            {
                padding-top:280px;
            }
        }

        .section--prefooter
        {
            .image
            {
                background-position: top center;
            }
        }

        .b-cards
        {
            display:block;
            max-width:1600px;
            .slick-track
            {
                display:flex;
            }
            .slick-slide
            {
                height:inherit;
                min-height:100%;
            }
            .slick-slide > div
            {
                height:inherit;
                min-height:100%;
                display: flex;
            }
            .b-slide
            {
                height:inherit;
                flex:1;
                margin:0;
            }
            .content,
            .b-card
            {
                height:100%;
                cursor:pointer;
            }
            .b-card
            {
                display:flex;
                flex-direction: column;
                &--text
                {
                    flex:1;
                }
            }
            .b-card--text
            {
                margin-top:-20px;
            }
            @include media-breakpoint-down(md)
            {
                .b-card--link
                {
                    //font-size: 12px;
                }
                .b-card--text
                {
                    margin-top:-60px;
                }
            }
        }


        .credito-travel
        {
            padding-top:0 !important;
            margin-bottom:0 !important;
            .title
            {
                color:$dark-blue;
                text-align: center;
                position:absolute;
                top:30%;
                padding:0 4%;
                font-weight: bold;
            }

            .drop
            {
                margin-top:-40px;
            }

            @include media-breakpoint-up(md)
            {
                .title
                {
                    width:100%;
                }
            }
            @include media-breakpoint-up(xl)
            {
                .title
                {
                    width:100%;
                }
                .drop
                {
                    max-width: 540px;
                    bottom:80px;
                }
            }
        }        

        .prods
        {
            //color:#9D9D9C;
            .dot
            {
                max-width: 80px;
                @include media-breakpoint-up(lg)
                {
                    max-width: 120px;
                    transform:translateY(-70%);
                }
            }
            .image
            {
                //position:absolute;
                //left:50%;
                //top:75%;
                margin-top:40px;
            }
            .btn
            {
                position:absolute;
                bottom:10%;
                right:10%;
            }
        }

        .yellow .box *
        {
            color:#333333;
        }
    }
</style>